import { render, staticRenderFns } from "./WhosHot.vue?vue&type=template&id=acdd0712&scoped=true"
import script from "./WhosHot.vue?vue&type=script&lang=js"
export * from "./WhosHot.vue?vue&type=script&lang=js"
import style0 from "./WhosHot.vue?vue&type=style&index=0&id=acdd0712&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acdd0712",
  null
  
)

export default component.exports